import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import Fade from 'react-reveal/Fade';

import u1 from '../../img/Bonus/u1.png';
import u2 from '../../img/Bonus/u2.png';


function UniqueBonuses () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#F8F8F8]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[100px] xl:mt-[160px]">
                <div className="flex flex-col md:flex-row justify-between gap-[20px]">
                    <div>
                        <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('bonus.13')}</Trans></p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd"><Trans>{t('bonus.14')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[30px] inter text-[14px] xl:text-[16px] font-[600] md:max-w-[525px] fdfd"><Trans>{t('bonus.15')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd"><Trans>{t('bonus.16')}</Trans></p>
                    </div>
                    <Fade right><img src={u1} alt="" className="mx-auto md:mx-0 md:w-[50%] xl:w-auto"/></Fade>
                </div>
                <div className="flex flex-col md:flex-row-reverse justify-between md:items-center gap-[20px]">
                    <div>  
                        <p className="mt-[15px] xl:mt-[30px] inter text-[14px] xl:text-[16px] font-[600] md:max-w-[525px] fdfd"><Trans>{t('bonus.17')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd"><Trans>{t('bonus.18')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd"><Trans>{t('bonus.19')}</Trans></p>
                        <Button className={"mt-[30px] xl:mt-[40px]"}/>
                    </div>
                    <Fade left><img src={u2} alt="" className="mx-auto md:mx-0 md:w-[50%] xl:w-auto"/></Fade>
                </div>
            </div>
        </div>
    );
}

export default UniqueBonuses;